import React from 'react';
import { Pedido } from '../../types';
import PedidoCard from './components/PedidoCard/PedidoCard';
import MiniLoadingSpinner from '../../../../../components/Spinners/MiniLoadingSpinner';
import './PedidosView.scss';

interface PedidosViewProps {
  pedidos: Pedido[];
  onSelectPedido: (pedido: Pedido) => void;
  selectedPedido?: Pedido | null;
  onMarkAsDelivered?: (pedido_id: number) => void;
  onCancel?: (pedido_id: number) => void;
  loading?: boolean;
}

const PedidosView: React.FC<PedidosViewProps> = ({
  pedidos,
  onSelectPedido,
  selectedPedido,
  onMarkAsDelivered,
  onCancel,
  loading = false,
}) => {
  if (loading) {
    return <MiniLoadingSpinner phrases={[]} left='50%' />;
  }

  if (pedidos.length === 0) {
    return (
      <div className="pedidos-view-empty">
        <div className="empty-state">
          <div className="empty-icon">📦</div>
          <h3>No hay pedidos pendientes</h3>
          <p>Los pedidos de delivery y retiro en local aparecerán aquí</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pedidos-view-container">
      <div className="pedidos-grid">
        {pedidos.map((pedido) => (
          <PedidoCard
            key={pedido.pedido_id}
            pedido={pedido}
            onSelect={() => onSelectPedido(pedido)}
            isSelected={selectedPedido?.pedido_id === pedido.pedido_id}
            onMarkAsDelivered={onMarkAsDelivered}
            onCancel={onCancel}
          />
        ))}
      </div>
    </div>
  );
};

export default PedidosView;
